import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Project} from '../../shared/models/project';
import {YesNoDialogComponent} from '../../yesno-dialog/yesno-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {CartService} from '../../shared/services/cart.service';
import {ProductsService} from '../../shared/services/products.service';
import {environment} from '../../../environments/environment';
import {Subscription} from "rxjs";

@Component({
    selector: 'mbnm-price-and-buy',
    templateUrl: './price-and-buy.component.html',
    styleUrls: ['./price-and-buy.component.scss'],
    host: {
        '[class.edit-mode]': 'project?.originalId ? true : false',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PriceAndBuyComponent implements OnInit, OnDestroy {

  constructor(public dialog: MatDialog, public productsService: ProductsService) { }

  @Input() project: Project;

  @Output('addToCartClicked')
  addToCartClickedEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Output('cancelEditClicked')
  cancelEditClickedEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  options: Array<any> = [];

  unitPriceInfoClicked() {
    const dialogRef = this.dialog.open(YesNoDialogComponent,{});
    const instance = dialogRef.componentInstance;
    instance.data = {
      closeMethod: 'x',
      title: 'How We Calculate Price',
      message: '<p><strong>Factors Affecting Price</strong></p><ul><li>Changing the Quantity <i>(Volume Pricing Discounts!)</i></li><li>Adjusting Outer Size</li><li>Chosen Mat Product</li><li>Choosing Add-Ons</li><li>Selecting an Accent Mat</li><li>Oval Opening</li></ul>' +
      '<p><strong>Factors <u>Not</u> Affecting Price</strong></p><ul><li>Changing Mat Colors</li><li>Adjusting Opening Size</li><li>Adjusting Reveal</li><li>Adjusting Bottom Margin</li></ul>',
      titleStyle: 'leftAligned'
    };
  }

  public canDisableAddToCart: boolean;
  addToCartClicked($event) {
    $event.currentTarget.blur();

    if (this.project.updating) {
      this.canDisableAddToCart = true;
    }
    this.addToCartClickedEventEmitter.emit();
  }

  cancelEditClicked() {
    this.cancelEditClickedEventEmitter.emit();
  }

  currentCartIsOrder: boolean;
  private cartSubRef: Subscription;

  ngOnInit() {
    this.cartSubRef = CartService.currentCartChanged.subscribe( (currentCart) => {
      this.currentCartIsOrder = currentCart ? currentCart.orderConfirmationNumber : false;
    });

/* not currently showing example prices so turn off for now

    this.project.change.subscribe( proj => {
      this.updateExamplePrices(this.project.partsUsed);
    });
    this.updateExamplePrices(this.project.partsUsed);
*/
  }

  ngOnDestroy() {
    if (this.cartSubRef && !this.cartSubRef.closed) {
      this.cartSubRef.unsubscribe();
    }
  }

  get qtySuggestions(): Array<number> {
    const currentQty = this.project.qty ? this.project.qty : 1;

    const retValue = [Math.ceil(currentQty/5)*5].concat(environment.qtySuggestions.filter(qty => {
      return qty > currentQty;
    })).filter( (val, idx, self) => {
      return self.indexOf(val) === idx;
    });

    const within = function(val, l, h) {
      return val >= l && val <= h;
    };

    while (within(retValue[0], currentQty, currentQty + 2)) {
      retValue.splice(0,1);
    }

    return retValue;
  }

  async updateExamplePrices(usedProducts: Array<string>) {
    const qtys = this.qtySuggestions;
    const results = await this.productsService.discounts(qtys, usedProducts);
    this.options = results.map( (result, i) => {
      return {
        qty: qtys[i],
        savings: result
      }
    });
  }

  get canBuy(): boolean {
    return this.project && this.project.canBuy;
  }

  get canPrice(): boolean {
    if (this.project.primaryProduct == 'MAT' && this.project.numMats == 0) {
      return false;
    } else if (this.project.primaryProduct == 'FRAME' && !this.project.moulding) {
      return false;
    }

    if (this.project.size.incomplete) {
      return false;
    }

    return true;
  }

  get completionText():string {
    // no completion text for samples
    if (this.project.primaryProduct === 'SAMPLE') return null;

    const parts = [];
    if (this.project.primaryProduct === 'MAT' && this.project.numMats === 0) {
      parts.push('choose mat');
    } else if (this.project.primaryProduct === 'FRAME' && !this.project.moulding) {
      parts.push('choose frame');
    }

    if (this.project.size.incomplete) {
      if (parts.length === 0) parts.push('enter size');
      else parts.push('size');
    }

    if (!this.project.qty) {
      if (parts.length === 0) parts.push('enter quantity');
      else parts.push('quantity');
    }

    if (parts.length === 0) return null;
    else if (parts.length === 1) return parts[0] + '<br />for exact pricing';
    else if (parts.length === 2) return parts.join(' & ') + '<br />for exact pricing';
    else return parts[0] + ', ' + parts[1] + ' & ' + parts[2] + '<br />for exact pricing';
  }
}
